import { getZ3kEntityById } from 'z3k-parser/lib/auxiliary';
import { RadioSensor, } from 'z3k-config';
import { getAnalogInputSensor, getBoilerAdapterSensor, getRadioSensor, getRadioSensor433, selectSensors, } from './utils';
import { createSelector } from '@reduxjs/toolkit';
import { Z3kSecondRoutes } from 'z3k-settings/routes/type';
export function getSharedSensorConfig(sensor, z3k_config, index) {
    const { id } = sensor;
    const [sensor_key] = getZ3kEntityById(z3k_config, id);
    if (!sensor_key) {
        return null;
    }
    if (sensor_key === 'analog_inputs') {
        const analog_input_sensor = sensor;
        const analog_input = getAnalogInputSensor(z3k_config, analog_input_sensor);
        return {
            ...analog_input,
            sensor_key: Z3kSecondRoutes.analog_inputs,
        };
    }
    if (sensor_key === 'radiosensors') {
        const z3k_radio_sensor = sensor;
        const show_radio_sensor = [
            RadioSensor.Type.LEAK,
            RadioSensor.Type.MOTION,
            RadioSensor.Type.HUMIDITY,
        ].includes(z3k_radio_sensor.type);
        if (show_radio_sensor) {
            const radio_sensor = getRadioSensor(z3k_radio_sensor);
            return {
                ...radio_sensor,
                sensor_key: Z3kSecondRoutes.radiosensor868,
            };
        }
        return null;
    }
    if (sensor_key === 'radiosensors433') {
        const z3k_radio_sensor_433 = sensor;
        const radio_sensor_433 = getRadioSensor433(z3k_radio_sensor_433);
        return {
            ...radio_sensor_433,
            sensor_key: Z3kSecondRoutes.radiosensor433,
        };
    }
    if (sensor_key === 'boiler_adapters') {
        const z3k_boiler_adapter_sensor = sensor;
        const boiler_adapter_sensor = getBoilerAdapterSensor(z3k_boiler_adapter_sensor, index);
        return {
            ...boiler_adapter_sensor,
            sensor_key: Z3kSecondRoutes.boiler_adapters,
        };
    }
    return null;
}
const array = [];
export const getZ3KSensorsConfig = createSelector(selectSensors, (z3k_config) => z3k_config, (sensors, z3k_config) => {
    if (sensors.length === 0) {
        return array;
    }
    return sensors.map((sensor, index) => getSharedSensorConfig(sensor, z3k_config, index));
});
